





















































































































































import Vue from 'vue';
// import buyerM, { Buyer } from '@/modules/buyer/buyer';
// import companyM, { Company } from '@/modules/buyer/company';
// import { calender } from 'mostra';
import {
  buyer as buyerM,
  Buyer,
  buyerCompany,
  BuyerCompany,
  calender,
  message,
  contact,
  ContactListItem,
} from 'mostra';

export type BuyerInfo = {
  buyer: Buyer;
  company: BuyerCompany;
}

export type DataType = {
  buyer: BuyerInfo | null;
  loading: boolean;
  contactList: ContactListItem[] | null;
};

export default Vue.extend({
  name: 'admin-admin-buyer-detail',
  data(): DataType {
    return {
      buyer: null,
      loading: true,
      contactList: null,
    };
  },
  async mounted() {
    this.loading = true;
    this.$loading(true);
    try {
      const cid = this.$route.params.id;
      const b = await buyerM.loadByCID(cid);

      if (!b || !b.data.cid) {
        throw Error('can not find cid!');
      }

      const cp = await buyerCompany.load(cid);
      if (!cp) {
        throw Error('can not find cid!');
      }
      this.buyer = {
        buyer: b,
        company: cp,
      };

      this.contactList = await contact.loadContactListByBuyer(cid, true);

      // console.log('buyer', this.buyer);
      // console.log('contactList', this.contactList);
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.loading = false;
      this.$loading(false);
    }
  },
  methods: {
    latestMessage(messages: any[]) {
      const m = messages[messages.length - 1];
      return m || { id: null, data: {} };
    },
    typeStr(t: number) {
      return message.typeOfString(t);
    },
    formatDate(dt: any) {
      return calender.formatDate(dt);
    },
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    async onClickUpdateCompany() {
      this.$loading(true);
      try {
        if (!this.buyer || !this.buyer.company) throw new Error('buyer is null');
        const uid = this.$auth.uid;
        this.buyer.company = await buyerCompany.save(uid, this.buyer.company);
        this.$success('保存しました');
      } catch (error: any) {
        this.$error('保存に失敗しました', error);
      } finally {
        this.$loading(false);
      }
    },
  },
});
